import React, { ReactNode } from "react";

import { Translate } from "@/app/application/Translate";
import CloseIcon from "@mui/icons-material/Close";
import {
	Box,
	Dialog,
	DialogContent,
	IconButton,
	Typography,
	alpha,
} from "@mui/material";

interface FullscreenChartDialogProps {
	open: boolean;
	onClose: () => void;
	translationKey: string;
	defaultText: string;
	children: ReactNode;
}

export const FullscreenChartDialog: React.FC<FullscreenChartDialogProps> = ({
	open,
	onClose,
	translationKey,
	defaultText,
	children,
}) => (
	<Dialog
		open={open}
		onClose={onClose}
		fullScreen
		PaperProps={{
			sx: (theme) => ({
				bgcolor:
					theme.palette.mode === "dark"
						? "background.default"
						: "background.paper",
			}),
		}}
	>
		<DialogContent sx={{ position: "relative", pt: 6, px: { xs: 2, sm: 3 } }}>
			<Box position="absolute" top={16} right={16}>
				<IconButton
					onClick={onClose}
					sx={(theme) => ({
						border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
						bgcolor: alpha(theme.palette.background.paper, 0.9),
					})}
				>
					<CloseIcon />
				</IconButton>
			</Box>
			<Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
				<Translate String={translationKey}>{defaultText}</Translate>
			</Typography>
			{children}
		</DialogContent>
	</Dialog>
);
